import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-order-draft-card-block',
    templateUrl: './order-draft-card-block.component.html',
    standalone: false
})
export class OrderDraftCardBlockComponent {
    @Input() numberFrom: string;
    @Input() numberTo: string;
}
